export const STRIPE_STATE_NONE = 'none';
export const STRIPE_STATE_PENDING = 'pending';
export const STRIPE_STATE_VERIFIED = 'verified';
export const STRIPE_STATE_REJECTED = 'rejected';

/**
 * @param {object|null} account stripe_connect row from API
 * @param {object} [apiMeta] optional { stripe_state, can_accept_payments } from get_connect_account
 */
export function resolveStripeConnectState(account, apiMeta = {}) {
  if (apiMeta.stripe_state) {
    return apiMeta.stripe_state;
  }

  if (!account || !account.stripe_connect_id) {
    return STRIPE_STATE_NONE;
  }

  const payoutsEnabled = account.payouts_enabled === 1 || account.payouts_enabled === true;
  const identityVerified = account.identity_verified === 1 || account.identity_verified === true;
  const status = String(account.status || '').toLowerCase();

  if (payoutsEnabled && (identityVerified || status === 'active')) {
    return STRIPE_STATE_VERIFIED;
  }

  if (status === 'rejected') {
    return STRIPE_STATE_REJECTED;
  }

  return STRIPE_STATE_PENDING;
}

export function canAcceptBookingPayments(account, apiMeta = {}) {
  if (typeof apiMeta.can_accept_payments === 'boolean') {
    return apiMeta.can_accept_payments;
  }
  return resolveStripeConnectState(account, apiMeta) === STRIPE_STATE_VERIFIED;
}

export function parseStripeErrorResponse(error) {
  const data = error?.response?.data || error?.data || error || {};
  return {
    code: data.code || null,
    message: data.message || error?.message || null,
    stripeState: data.stripe_state || null,
    status: data.status || error?.status || null,
  };
}
